// Deterministischer Zufall — bitgleich zur Python-Seite (Gate FG-30).
//
// Client und Server rechnen dasselbe Asteroidenfeld **getrennt** aus. Weichen
// sie ab, schiesst der Spieler auf einen Brocken, den der Server nicht kennt.
// Deshalb ist dieses Modul die exakte Entsprechung von
// `backend/farmining/core/rng.py`.
//
// Wer hier etwas „verbessert", aendert jede erzeugte Welt. Der Golden Vector
// unter `contracts/determinism.json` ist die Wache.

/** Deterministischer PRNG (mulberry32). */
export function rngFrom(seed: number): () => number {
  let a = seed >>> 0;
  return function next(): number {
    a |= 0; a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Stabiler Hash aus drei Ganzzahlen -> uint32 (FNV-1a, fuer Chunk-Saaten). */
export function hash3(x: number, y: number, z: number): number {
  let h = 2166136261 >>> 0;
  for (const value of [x | 0, y | 0, z | 0]) {
    h ^= value & 0xff;          h = Math.imul(h, 16777619);
    h ^= (value >>> 8) & 0xff;  h = Math.imul(h, 16777619);
    h ^= (value >>> 16) & 0xff; h = Math.imul(h, 16777619);
    h ^= (value >>> 24) & 0xff; h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Der Generator eines Chunks — haengt **nur** an Koordinate und Weltsaat. */
export function rngForChunk(cx: number, cy: number, worldSeed: number): () => number {
  return rngFrom(hash3(cx, cy, worldSeed));
}

/**
 * Nicht-deterministischer Zufall fuer Darstellung und Ausschuettung.
 *
 * Bewusst getrennt benannt: `rnd` gehoert nie in die Weltgenerierung. Was
 * persistente Struktur erzeugt, laeuft ausschliesslich ueber `rngFrom`.
 */
export const rnd = (a = 1, b?: number): number =>
  b === undefined ? Math.random() * a : a + Math.random() * (b - a);

export const chance = (p: number): boolean => Math.random() < p;
